import {UserGeographicalAssignmentTypes} from "./UserGeographicalAssignmentTypes";
import {Country} from "./Country";

export class Region {
  regionId?: number;
  isCustom?: boolean;
  regionText?: string;
  countryList?: Array<Country>;
  userGeographicalAssignmentType?: UserGeographicalAssignmentTypes;

  // These fields are used by front end only. Don't send them to backend.
  __selected?: boolean;

  static isRegionAssignment(region : Region) {
    let type : any = region.userGeographicalAssignmentType;
    if(typeof type === 'string') {
      return type === UserGeographicalAssignmentTypes[UserGeographicalAssignmentTypes.Region];
    }
    else {
      return type === UserGeographicalAssignmentTypes.Region;
    }
  }

  static isGlobalAssignment(region : Region) {
    let type : any = region.userGeographicalAssignmentType;
    if(typeof type === 'string') {
      return type === UserGeographicalAssignmentTypes[UserGeographicalAssignmentTypes.Global];
    }
    else {
      return type === UserGeographicalAssignmentTypes.Global;
    }
  }

  static isCustomAssignment(region : Region) {
    let type : any = region.userGeographicalAssignmentType;
    if(typeof type === 'string') {
      return type === UserGeographicalAssignmentTypes[UserGeographicalAssignmentTypes.CustomCountryList];
    }
    else {
      return type === UserGeographicalAssignmentTypes.CustomCountryList;
    }
  }
}
